module.exports = __webpack_public_path__ + "static/media/food-drink.566e165e.svg";